import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .constant(
            'GENERAL_VALIDATION_ERROR',
            'app/includes/generalValidationError.html'
        )
        .constant('GENERAL_ERROR', 'app/includes/generalError.html');
})();
